import React, { useEffect, useState } from "react";
import StepHeader from "../AdFormPage/StepHeader";
import BackButton from "../AdFormPage/StepHeader/BackButton";
import history from "../../history";
import { LocalStorageKey } from "../../models";
import { handleAdFormLayoutMobile } from "../../HOCs";

import styles from "./styles/selectModulePage.scss";
import { requireUserLogin, requireUserVerify } from "../../routes/Auth";
import requireUsernameChange from "../../routes/Auth/HOCs/requireUsernameChange";
import TitleWithModule from "./TitleWithModule";
import confirmModal from "../../services/confirmModal";
import { api, localStorage } from "../../services";
import { useDispatch } from "react-redux";

import { getControls, setAdData } from "../../routes/AdForm/adForm.ducks";
import HelmetComponent from "../../utils/HelmetHelper";
import { mapCategoryToHr, mapModuleToHr } from "../../routes/LanguageMapper";

const SelectModulePage = props => {
  const [draftLoaded, setDraftLoaded] = useState(false);
  useEffect(() => {
    let draftedData = localStorage.getItem(LocalStorageKey.savedForm);
    if (draftedData) {
      showSaveProcessConfirmation(draftedData);
    }
  }, []);

  const dispatch = useDispatch();

  function showSaveProcessConfirmation(adForm) {
    const {
      location: { pathname },
      match: { path }
    } = props;

    confirmModal.show({
      title: "Nedovršeni oglas",
      okText: "Dovrši oglas",
      cancelText: "Objavi novi oglas",
      onCancel: () => {
        // Post new ad
        dispatch(
          getControls(
            mapModuleToHr(adForm.module),
            mapCategoryToHr(adForm.category),
            [],
            null
          )
        );

        localStorage.removeItem(LocalStorageKey.savedForm);
        if (!pathname.endsWith(adForm.category)) {
          history.replace(path);
        }
      },
      onOk: () => {
        // Finish old draft ad
        if (adForm.module && adForm.category) {
          dispatch(setAdData(adForm));
          setDraftLoaded(true);
        } else {
          history.goBack();
        }
      },
      children: "Imate spremljen nedovršeni oglas. Želite li ga dovršiti ili započeti novi?",
      className: styles.confirmModal
    });
  }

  return (
    <React.Fragment>
      <HelmetComponent title={`${"Objavi oglas"} | ${"INDEX OGLASI"}`} index={false} />

      <StepHeader
        leftButton={<BackButton onClick={() => history.push("/")} />}
      />

      <TitleWithModule
        {...props}
        draftLoaded={draftLoaded}
        title={"Odaberite kategoriju"}
      />
    </React.Fragment>
  );
};

export default requireUserLogin(
  requireUsernameChange(
    requireUserVerify(
      handleAdFormLayoutMobile(
        SelectModulePage
      )
    )
  )
);



// WEBPACK FOOTER //
// ./src/containers/SelectModulePage/index.tsx